import { DayLabels, dayLabels } from 'Shared/common/DayLabels';
import { formatDateTime } from 'Shared/common/Macros';
import { Match, Show, Switch } from 'solid-js'

export function BusinessHoursEntry(props)
{
	const daysList = (days: (keyof DayLabels)[]) => {
		let result = ''
		let sep;
		for (let i=0; i < days.length; i++) {
			if (i == days.length - 1)
				sep = ': ';			//XXX ????
			else if (i == days.length - 2)
				sep = ' and ';
			else
				sep = ', ';

			result += `${dayLabels[days[i]]}${sep}`;
		}
		return result;
	};

	return (
		<Switch>
			<Match when={props.createSectionHeading}>
				<h5>{props.sectionHeading}</h5>
			</Match>
			<Match when={props.customLabel}>
				{props.customLabel}
			</Match>
			<Match when={true}>
				{props.daysopen=='other' ? props.otherDays : daysList(props.daysopen ?? []) }

				<Show when={props.opens} fallback='Closed'> 
					{formatDateTime(props.opens,'h:mma')}
					- {props.closes ? formatDateTime(props.closes,'h:mma') : 'Late'}
				</Show>
			</Match>
		</Switch>
	);
}

